export const JOURNEY_ROUTES = {
  SESSIONS: 'sessions',
  COACHES: 'coaches',
  MEMBERSHIP: 'membership',
  ONE_TO_ONE: 'one-to-one',
  LIVE: 'live',
};
